import styled from "styled-components";

export const ModalContainer = styled.div<{ isMobile?: boolean }>`
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 95vw;
  min-width: ${(props) => (props.isMobile ? "300px" : "560px")};
  min-height: ${(props) => (props.isMobile ? "400px" : "320px")};
  background-color: #ffffff;
`;

export const ModalContentContainer = styled.div<{ isMobile?: boolean }>`
  margin-top: ${(props) => (props.isMobile ? "15%" : "5%")};
  margin-left: ${(props) => (props.isMobile ? "10px" : "5%")};
  margin-right: ${(props) => (props.isMobile ? "10px" : "5%")};
`;

export const ButtonAreaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
`;
